<template>
  <v-app>
    <router-view />

    <v-snackbar v-model="snackbar" :timeout="3000" color="primary">
      {{ snackbarText }}
      <v-btn text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    snackbar: false,
  }),
  computed: {
    snackbarText() {
      const text = this.$store.getters['snackbar/getSnackbarText']
      if (text !== null) {
        this.snackbar = true
      }
      return text
    },
  },
}
</script>
